import {BuildPageTabNamesEnum} from '../../../../../types'

export const supportedTabs = [
  BuildPageTabNamesEnum.OVERVIEW,
  BuildPageTabNamesEnum.LOG,
  BuildPageTabNamesEnum.TESTS,
  BuildPageTabNamesEnum.ARTIFACTS,
]
